import { useEffect } from 'react';
import { useGeoLocation } from 'hooks/useGeoLocation';

interface Props {
  children?: React.ReactNode;
}

/**
 * Component that triggers geolocation initialization when mounted.
 * Use this on pages that need geolocation features.
 */
export default function GeoLocationInitializer({ children }: Props) {
  const { initializeGeoLocation } = useGeoLocation();

  useEffect(() => {
    // Initialize geolocation when component mounts
    initializeGeoLocation();
  }, []);

  // This component doesn't render anything, just triggers initialization
  return <>{children}</>;
}
